(()=>{"use strict";function e(e=document.body,t="js-"){const n=[...e.querySelectorAll(t?`[class*="${t}"]`:"*")],o=t?"classList":"dataset";return n.reduce(((e,n)=>([].slice.call(t?n[o]:Object.entries(n[o])).forEach((o=>{let a;t&&o.slice(0,t.length)===t?a=o.slice(t.length,o.length):t||([a]=o),a&&(e[a]=e.hasOwnProperty(a)?e[a].constructor===Array?e[a].concat(n):[e[a],n]:n)})),e)),{})}const t={hero:window.component((async t=>{const{video:n,source:o}=e(t,null),{desktopSource:a,mobileSource:s}=n.dataset,r=async()=>{window.innerWidth>=1024&&a&&o.src!==a?(o.src=a,n.load(),await n.play(),n.classList.add("open")):window.innerWidth<1024&&s&&o.src!==s&&(o.src=s,n.load(),await n.play(),n.classList.add("open"))};window.addEventListener("resize",r,{passive:!0}),window.addEventListener("load",(()=>{r()}),{passive:!0})}))},n=window.component((()=>{document.addEventListener("shopify:section:load",(()=>{window.app.unmount(),window.app.mount()}))})),o=window.component((e=>{const{text:t}=e.dataset;console.log("console:log",t)})),a=window.component((t=>{const{toggle:n}=e(t,null);n.addEventListener("click",(()=>{t.classList.toggle("is-active")}))})),s=window.component(((t,n)=>{const{cartToggle:o,menuToggle:a,menuOverlay:s}=e(t,null),r=[].concat(o);a.addEventListener("click",(()=>{a.classList.toggle("is-active"),s.classList.toggle("is-active"),n.emit("body:toggleScrollLock",{enable:s.classList.contains("is-active")})})),r.forEach((e=>e.addEventListener("click",(()=>{n.emit("cart:toggle",{cartOpen:!0})}))));const c=t.getBoundingClientRect().top+t.offsetHeight+25;let i=0;window.addEventListener("scroll",(()=>{const e=window.scrollY||0,n=e<=c||"up"==(e<i?"up":"down");t.parentElement.classList[n?"remove":"add"]("is-active"),i=e,e>50?t.classList.add("is-scrolled"):t.classList.remove("is-scrolled")}),{passive:!0})})),r=window.component((async t=>{const{slider:n,item:o}=e(t,null);let a=0,{speed:s}=n.dataset;s=parseInt(s,10);const r=[].concat(o);r.length>1&&window.setInterval((()=>{a=a===r.length-1?0:a+1;const e=`translateY(-${r[0].offsetHeight*a}px)`;n.style.transform=e}),s)})),c=window.component(((t,n)=>{const{mobileMenuToggle:o,mobileMenuContainer:a,mobileNestedMenuButton:s,mobileNestedMenu:r,mobileNestedMenuBackButton:c,mobileMenu:i}=e(t,null),d=[].concat(o),l=[].concat(s),u=[].concat(r),p=[].concat(c);d.length>0&&d.forEach((e=>{e?.addEventListener("click",(()=>n.emit("mobileMenu:toggle",(({mobileMenuOpen:e})=>({mobileMenuOpen:!e})))))})),l.length>0&&l.forEach((e=>{e?.addEventListener("click",(()=>{const{menuId:t}=e.dataset;i.classList.add("open"),u.forEach((e=>e.classList.add("hidden"))),u.find((e=>e.id===t)).classList.remove("hidden")}))})),p.length>0&&p.forEach((e=>{e?.addEventListener("click",(()=>i.classList.remove("open")))})),n.on("mobileMenu:toggle",(({mobileMenuOpen:e})=>{n.emit("body:toggleScrollLock",(()=>({enable:e}))),a.classList[e?"add":"remove"]("open")}))}));const i=({keyCode:e},{type:t,boolean:n})=>{27===e&&t&&n&&window.app.emit(t,{[n]:!1})},d=window.component(((t,n)=>{const o=t.parentNode,a=t,{toggle:s,clear:r,focusEl:c}=e(t,null),d=({cartOpen:e})=>{t.classList[e?"add":"remove"]("open"),e?(a.tabIndex="0",(c||t).focus()):a.tabIndex="-1"};return s.forEach((e=>{e.addEventListener("click",(()=>n.emit("cart:toggle",(({cartOpen:e})=>({cartOpen:!e??!0})))))})),d(n.getState()),r&&r.addEventListener("click",(()=>(window.app.emit("cart:updating"),fetch(`${window.NaturallyCooked.routes.cartClear}.js`,{method:"POST",credentials:"include",headers:{"Content-Type":"application/json"},body:JSON.stringify({sections:"cart-drawer"})}).then((e=>e.json())).then((e=>(window.app.emit(["cart:updated","cart:render"],{cart:e}),e)))))),t.addEventListener("keyup",(e=>i(e,{type:"cart:toggle",boolean:"cartOpen"}))),n.on("cart:render",(({cart:e})=>{e.message||(o&&(document.getElementById("shopify-section-cart-drawer").outerHTML=e.sections["cart-drawer"]),window.app.unmount(),window.app.mount())})),n.on("cart:toggle",d),()=>{n.on(["cart:toggle","cart:render"],(()=>{}))(),t.removeEventListener("keyup",(e=>i(e,{type:"cart:toggle",boolean:"cartOpen"})))}})),l=window.component((t=>{const{update:n}=e(t,null),{key:o}=t.dataset;[].concat(n).forEach((e=>{const{value:t}=e.dataset;e.addEventListener("click",(()=>function(e,t){return function(e,t){return window.app.emit("cart:updating"),fetch(`${window.NaturallyCooked.routes.cartChange}.js`,{method:"POST",credentials:"include",headers:{"Content-Type":"application/json"},body:JSON.stringify({id:e,quantity:t,sections:"cart-drawer"})}).then((e=>e.json())).then((async e=>(window.app.emit(["cart:updated","cart:render"],{cart:e}),e)))}(e,t)}(o,t)))}))})),u=window.component((async(e,t)=>{let n,o=0;t.on("body:toggleScrollLock",(({enable:t})=>{n!==t&&(t?(o=window.pageYOffset,e.style.overflow="hidden",e.style.position="fixed",e.style.top=`-${o}px`,e.style.width="100%"):(e.style.removeProperty("overflow"),e.style.removeProperty("position"),e.style.removeProperty("top"),e.style.removeProperty("width"),window.scrollTo(0,o)),n=t)}))})),p=window.component(((t,n)=>{const{toggleButton:o,searchInput:a,dynamicContent:s,loader:r}=e(t,null),c=[].concat(o),{debounceDelay:i}=t.dataset;c.forEach((e=>{e?.addEventListener("click",(()=>n.emit("search:toggle",(({searchOpen:e})=>({searchOpen:!e})))))}));const d=()=>{const e=a.value;if(/[a-z0-9]/i.test(e)){let t;r.classList.remove("hidden"),s.classList.add("hidden"),fetch(`${window.Shopify.routes.root}search/suggest?q=${e}&resources[type]=product&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,variants.title,variants.sku,body,tag&section_id=predictive-search`).then((e=>(t=e,e.text()))).then((e=>{if(!t.ok)throw new Error(`${t.status}: ${e}`);const n=(new DOMParser).parseFromString(e,"text/html");r.classList.add("hidden"),s.innerHTML=n.querySelector("[data-dynamic-content]").innerHTML,s.classList.remove("hidden"),window.app.mount()})).catch((e=>{console.error(e)}))}},l=()=>{const{searchResults:n,suggestedSearchTerms:o,featuredCollection:a}=e(t,null);n?.classList.add("hidden"),o?.classList.remove("hidden"),a&&"true"!==a?.dataset.alwaysHide&&a.classList.remove("hidden")},u=e=>{"Escape"===e.key&&(""===a.value?n.emit("search:toggle",(({searchOpen:e})=>({searchOpen:!e}))):(a.value="",l(),a.focus()))};n.on("search:toggle",(({searchOpen:e})=>{n.emit("body:toggleScrollLock",(()=>({enable:e}))),t.classList[e?"add":"remove"]("open"),e?(document.addEventListener("keyup",u),a.focus()):(t.tabIndex="-1",document.removeEventListener("keyup",u))})),a.addEventListener("keyup",function(e,t){let n;return function(...e){clearTimeout(n),n=setTimeout((()=>{n=null,(()=>{0===a.value.length?l():d()})(...e)}),t)}}(0,Number(i))),n.on("search:suggest-term-clicked",(({searchTerm:e})=>{a.value=e,d()}))})),m=window.component(((e,t)=>{const{searchTerm:n}=e.dataset;e.addEventListener("click",(()=>t.emit("search:suggest-term-clicked",(()=>({searchTerm:n})))))})),w=e=>e.split(".").reduce(((e,t)=>e?.[t]),window?.NaturallyCooked?.theme?.strings)||`Missing translation for ${e} in window.NaturallyCooked`,g={sectionRendering:n,consoleLog:o,accordion:a,header:s,announcementbar:r,mobileMenu:c,cartDrawer:d,cartItem:l,body:u,predictiveSearch:p,suggestedSearchTerm:m,productItem:window.component(((t,n)=>{const{submit:o,optionMain:a}=e(t,null),s=t.querySelector("form"),{productId:r}=t.dataset;let c=null;s&&(a.addEventListener("change",(()=>{c=a.value,o.textContent=w("product.add_to_cart"),o.disabled=!1})),s.addEventListener("submit",(e=>{var t,a;e.preventDefault(),o.disabled=!0,o.textContent=w("product.adding_to_cart"),(t=c,a=s.elements.quantity.value,function(e=[]){return window.app.emit("cart:updating"),fetch(`${window.NaturallyCooked.routes.cartAdd}.js`,{method:"POST",credentials:"include",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:e})}).then((e=>e.json())).then((async e=>{if(e.status)return window.app.emit(["cart:updated","cart:error"],null,e),{item:e,cart:window.app.getState().cart,error:e?.description};const[t,n]=await Promise.all([fetch(`${window.NaturallyCooked.routes.cart}.js`,{method:"GET",credentials:"include"}).then((e=>e.json())),fetch(`${window.NaturallyCooked.routes.cart}?sections=cart-drawer`,{method:"GET",credentials:"include"}).then((e=>e.json()))]);return t.sections=n,window.app.emit(["cart:updated","cart:render"],{cart:t}),{item:e,cart:t}}))}([{id:t,quantity:a,properties:undefined}])).then((({error:e})=>{e&&alert(e),o.disabled=!0,o.textContent=w("product.added_to_cart"),setTimeout((()=>{e||n.emit("cart:toggle",{cartOpen:!0})}),0),setTimeout((()=>{o.disabled=!1,o.textContent=w("product.add_to_cart")}),e?0:1e3)}))})))})),languageForm:window.component((t=>{const{languageSelect:n}=e(t,null);n.addEventListener("change",(()=>t.submit()))})),countryForm:window.component((t=>{const{countrySelect:n}=e(t,null);n.addEventListener("change",(()=>t.submit()))})),footerNewsletter:window.component(((t,n)=>{const{input:o,submit:a,error:s}=e(t,null);window.location.search.includes("customer_posted=true")&&t.scrollIntoView({behavior:"smooth"}),window.location.href.indexOf("&form_type=customer")>-1&&(s.innerHTML=w("newsletter.error")),o?.addEventListener("keyup",(()=>{/^[^\s()<>@,;:\/]+@\w[\w\.-]+\.[a-z]{1,}$/i.test(o.value)?(a.classList.add("opacity-100"),a.disabled=!1):(a.classList.remove("opacity-100"),a.disabled=!0)}))})),newsletterPopup:window.component((t=>{const{overlay:n,close:o,submit:a}=e(t,null),{duration:s}=t.dataset;n.addEventListener("click",(()=>{localStorage.setItem("newsletterPopup","1"),t.classList.remove("is-active")})),o.addEventListener("click",(()=>{localStorage.setItem("newsletterPopup","1"),t.classList.remove("is-active")})),a.addEventListener("click",(()=>{a.form.checkValidity()&&(localStorage.setItem("newsletterPopup","1"),a.form.submit())})),setTimeout((()=>{"1"!==localStorage.getItem("newsletterPopup")&&t.classList.add("is-active")}),parseFloat(s))}))};window.app.add(t),window.app.add(g),window.app.mount()})();

// Optimize script loading
function loadScript(src, attributes = {}) {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;
    
    // Add any additional attributes
    Object.entries(attributes).forEach(([key, value]) => {
      script[key] = value;
    });
    
    script.onload = resolve;
    script.onerror = reject;
    document.body.appendChild(script);
  });
}

// Defer Google Tag Manager loading
function loadGTM() {
  if (window.dataLayer) return Promise.resolve(); // Already loaded
  
  // Create dataLayer
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  
  // Load GTM script
  return loadScript('https://www.googletagmanager.com/gtag/js?id=G-9C1LC2DY3D', {
    async: true
  }).then(() => {
    gtag('js', new Date());
    gtag('config', 'G-9C1LC2DY3D');
  });
}

// Defer D3.js loading - only load when UV index section is in viewport
function loadD3() {
  if (window.d3) return Promise.resolve(); // Already loaded
  
  const uvSection = document.querySelector('.why-naturallycooked');
  if (!uvSection) return Promise.resolve();
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadScript('https://d3js.org/d3.v7.min.js').then(() => {
          observer.disconnect();
        });
      }
    });
  }, { threshold: 0.1 });
  
  observer.observe(uvSection);
}

// Defer Stamped.io loading - only load when reviews section is in viewport
function loadStamped() {
  if (window.Stamped) return Promise.resolve(); // Already loaded
  
  const reviewsSection = document.querySelector('.stamped-reviews-widget');
  if (!reviewsSection) return Promise.resolve();
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadScript('https://cdn1.stamped.io/assets/widget.min.js').then(() => {
          observer.disconnect();
        });
      }
    });
  }, { threshold: 0.1 });
  
  observer.observe(reviewsSection);
}

// Defer Klaviyo loading - only load when Klaviyo form is in viewport
function loadKlaviyo() {
  if (window._learnq) return Promise.resolve(); // Already loaded
  
  const klaviyoForm = document.querySelector('.klaviyo-form');
  if (!klaviyoForm) return Promise.resolve();
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        loadScript('https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=YOUR_COMPANY_ID').then(() => {
          observer.disconnect();
        });
      }
    });
  }, { threshold: 0.1 });
  
  observer.observe(klaviyoForm);
}

// Initialize critical functionality immediately
document.addEventListener('DOMContentLoaded', function() {
  // Initialize mobile menu and cart (critical functionality)
  initMobileMenu();
  initCart();
  
  // Defer non-critical functionality
  if (window.requestIdleCallback) {
    requestIdleCallback(function() {
      initSearch();
      initLazyLoading();
      loadGTM(); // Load GTM with lower priority
    });
  } else {
    setTimeout(function() {
      initSearch();
      initLazyLoading();
      loadGTM();
    }, 1000);
  }
  
  // Load third-party scripts only when needed
  loadD3();
  loadStamped();
  loadKlaviyo();
});

// Mobile menu toggle
function initMobileMenu() {
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
  
  if (mobileMenuToggle && mobileMenu && mobileMenuOverlay) {
    // Use a single state variable to track menu state
    let isMenuOpen = false;
    
    // Toggle menu function
    function toggleMenu() {
      isMenuOpen = !isMenuOpen;
      mobileMenu.classList.toggle('active', isMenuOpen);
      mobileMenuOverlay.classList.toggle('active', isMenuOpen);
      mobileMenuToggle.setAttribute('aria-expanded', isMenuOpen);
      document.body.style.overflow = isMenuOpen ? 'hidden' : '';
    }
    
    // Event listeners
    mobileMenuToggle.addEventListener('click', toggleMenu);
    mobileMenuOverlay.addEventListener('click', toggleMenu);
    
    // Close menu on escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && isMenuOpen) {
        toggleMenu();
      }
    });
  }
}

// Cart toggle
function initCart() {
  const cartToggle = document.querySelector('.cart-toggle');
  const cartDrawer = document.querySelector('.cart-drawer');
  
  if (cartToggle && cartDrawer) {
    cartToggle.addEventListener('click', function() {
      cartDrawer.classList.toggle('active');
      document.body.style.overflow = cartDrawer.classList.contains('active') ? 'hidden' : '';
    });
  }
}

// Search functionality
function initSearch() {
  const searchToggle = document.querySelector('.search-toggle');
  const searchDrawer = document.querySelector('.search-drawer');
  
  if (searchToggle && searchDrawer) {
    searchToggle.addEventListener('click', function() {
      searchDrawer.classList.toggle('active');
      if (searchDrawer.classList.contains('active')) {
        // Focus search input when drawer opens
        const searchInput = searchDrawer.querySelector('input[type="search"]');
        if (searchInput) {
          setTimeout(() => searchInput.focus(), 100);
        }
      }
    });
  }
}

// Lazy load images
function initLazyLoading() {
  if ('loading' in HTMLImageElement.prototype) {
    // Browser supports native lazy loading
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      // Only set src if data-src exists
      if (img.dataset.src) {
        img.src = img.dataset.src;
      }
    });
  } else {
    // Fallback for browsers that don't support lazy loading
    const script = document.createElement('script');
    script.src = 'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.3.2/lazysizes.min.js';
    document.body.appendChild(script);
  }
}

// Initialize third-party scripts
function initThirdPartyScripts() {
  // Initialize Swiper if it exists
  if (typeof Swiper !== 'undefined') {
    const swiperElements = document.querySelectorAll('.swiper');
    swiperElements.forEach(element => {
      const swiperOptions = JSON.parse(element.dataset.swiperOptions || '{}');
      new Swiper(element, swiperOptions);
    });
  }
  
  // Initialize GSAP animations if GSAP is loaded
  if (typeof gsap !== 'undefined') {
    initGSAPAnimations();
  }
}

// Initialize GSAP animations
function initGSAPAnimations() {
  // Register ScrollTrigger plugin
  if (gsap.registerPlugin) {
    gsap.registerPlugin(ScrollTrigger);
  }
  
  // Initialize animations that use GSAP
  // This is where you would add any GSAP animations that aren't critical
}

// Optimize event listeners with passive option where possible
document.addEventListener('touchstart', function() {}, { passive: true });
document.addEventListener('touchmove', function() {}, { passive: true });
document.addEventListener('wheel', function() {}, { passive: true });

// Use Intersection Observer for lazy loading and animations
if ('IntersectionObserver' in window) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        // Add your lazy loading or animation logic here
        const target = entry.target;
        
        // Example: Lazy load background images
        if (target.dataset.background) {
          target.style.backgroundImage = `url(${target.dataset.background})`;
          target.removeAttribute('data-background');
        }
        
        // Example: Animate elements when they come into view
        if (target.classList.contains('animate-on-scroll')) {
          target.classList.add('animated');
        }
        
        // Unobserve the target after it's been handled
        observer.unobserve(target);
      }
    });
  }, {
    rootMargin: '50px 0px',
    threshold: 0.1
  });
  
  // Observe elements that need lazy loading or animation
  document.querySelectorAll('[data-background], .animate-on-scroll').forEach(el => {
    observer.observe(el);
  });
}